import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-features',
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.scss'],
})
export class FeaturesComponent implements OnInit {
  dynamicTape = [
    {
      Id: 1,
      Text: 'আলিম বর্ষ সমাপনী পরীক্ষার নোটিশ',
      Link: '2.pdf',
      Date: new Date('2023-08-03'),
      Category: 'আলিম',
    },
    {
      Id: 2,
      Text: 'আলিম ভর্তি বিজ্ঞপ্তি ২০২৩-২০২৪',
      Link: '5.jpg',
      Date: new Date('2023-08-10'),
      Category: 'আলিম',
    },
    {
      Id: 3,
      Text: 'How To Pay Education Fee With Bkash App',
      Link: '4.jpg',
      Date: new Date('2023-08-10'),
      Category: 'সকল',
    },
    {
      Id: 4,
      Text: 'ফাজিল (স্নাতক) অনাসের ভতি নোটিশ (ভতি শেষ তারিখ 31-08-2023)',
      Link: 'FAZIL Hounors Notice 2022-23.pdf',
      Date: new Date('2023-08-27'),
      Category: 'ফাজিল',
    },
    {
      Id: 5,
      Text: 'ফাজিল (স্নাতক) অনাসের প্রথম মেধা তালিকা ও ভতির শেষ তারিখ- 31/08/23',
      Link: 'Fazil Hounours 2022-23.pdf',
      Date: new Date('2023-08-29'),
      Category: 'ফাজিল',
    },
    {
      Id: 6,
      Text: 'মেধাবৃত্তির ফরম - 2023',
      Link: 'onlineForm.pdf',
      Date: new Date('2023-08-30'),
      Category: 'সকল',
    },
    {
      Id: 7,
      Text: 'শিক্ষক নিয়োগ বিজ্ঞপ্তি ২০২৩',
      Link: 'hiring.pdf',
      Date: new Date('2023-08-30'),
      Category: 'সকল',
    },
    {
      Id: 8,
      Text: 'আলিম ভর্তি নির্দেশিকা (সংশোধিত) 2023-2024',
      Link: 'alimadmission.pdf',
      Date: new Date('2023-09-06'),
      Category: 'আলিম',
    },
    {
      Id: 9,
      Text: 'ফাজিল পাস প্রথম বর্ষের ওরিয়েন্টেশন ক্লাস ১১-০৯-২০২৩',
      Link: 'Fazl.pdf',
      Date: new Date('2023-09-09'),
      Category: 'ফাজিল',
    },
    {
      Id: 10,
      Text: 'ফাজিল অনার্স প্রথম বর্ষের ওরিয়েন্টেশন ক্লাস ১১-০৯-২০২৩',
      Link: 'HOns.pdf',
      Date: new Date('2023-09-09'),
      Category: 'ফাজিল',
    },
    {
      Id: 11,
      Text: 'আলিম ভর্তি বিজ্ঞপ্তি 2023-2024',
      Link: 'alim2023.pdf',
      Date: new Date('2023-09-26'),
      Category: 'আলিম',
    },
    {
      Id: 12,
      Text: 'আলিম ব্যবহারিক পরীক্ষা -২০২৩',
      Link: 'alimpractical.pdf',
      Date: new Date('2023-10-09'),
      Category: 'আলিম',
    },
    {
      Id: 13,
      Text: 'মেধাবৃত্তি ফরম',
      Link: 'OnlineForm (2).pdf',
      Date: new Date('2023-10-14'),
      Category: 'আলিম',
    },
    {
      Id: 14,
      Text: 'দাখিল ফরম পূরণ (eFF) বিজ্ঞপ্তি-২০২৪',
      Link: 'DakhilFormfillup (eef)-2024.pdf',
      Date: new Date('2023-10-26'),
      Category: 'দাখিল',
    },
    {
    Id: 15,
    Text: '২০২১-২০২২ শিক্ষাবর্ষে কামিল (এম.এ) ১ম পর্বে ভর্তি চলছে',
    Link: 'kamil admission notice.pdf',
    Date: new Date('2023-11-05'),
    Category: 'দাখিল',
  },
  {
  Id: 16,
  Text: 'ভর্তি বিজ্ঞপ্তি - ২০২৪',
  Link: 'AdmissionforNursery.pdf',
  Date: new Date('2023-11-28'),
  Category: 'দাখিল',
},
{
  Id: 17,
  Text: 'আলিম সিলেবাস ২০২৩-২০২৪ইং',
  Link: 'Alimfinalsyllabus 2023-2024.pdf',
  Date: new Date('2023-11-26'),
  Category: 'আলিম',
},

{
  Id: 18,
  Text: 'ভর্তি বিজ্ঞপ্তি ও নিয়মাবলী ২০২৪',
  Link: 'Result 2023.pdf',
  Date: new Date('2023-11-26'),
  Category: 'আলিম',
},

  ];

  pdfUrl: SafeResourceUrl | undefined;
  selectedNotice: any;

  constructor(private sanitizer: DomSanitizer) {
    this.dynamicTape.sort((a, b) => b.Date.getTime() - a.Date.getTime());
  }

  // transform(pdfUrl) {
  //   return this.sanitizer.bypassSecurityTrustResourceUrl(pdfUrl);
  // }

  ngOnInit(): void {}

  showNotice(event: Event, notice: any) {
    event.preventDefault();
    this.selectedNotice = notice;
    const pdfPath = 'assets/pdf/' + notice.Link + '#toolbar=0';
    this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(pdfPath);
  }

  isImage(link: string): boolean {
    return /\.(jpe?g|png|gif)$/i.test(link);
  }
}
